import React, { useRef } from "react";
import { ThreeDotsMenuIcon } from "./SvgIcons.jsx";
import { renderActionsDropdown } from "../utils/cardBodyRenderHelpers.js";
import TimeEntryPopup from "../trackerModules/TimeEntryLockModal.jsx";

const isElementVisible = (el) => {
  if (!el || typeof el.getBoundingClientRect !== "function") return false;
  const rect = el.getBoundingClientRect();
  return rect.width > 0 || rect.height > 0;
};

/**
 * ActionsDropdownWrapper Component
 * Wrapper component that includes the toggle button and actions dropdown
 */
const ActionsDropdownWrapper = ({
  // Item identification
  itemId,
  group,
  row,

  // Dropdown state
  activeDropdownId,
  setActiveDropdownId,

  // Loading states
  duplicateLoading,
  isDeleteLoading,
  deleteId,

  // Handlers
  handleDropdownToggleFunc,
  createActionsDropdownToggleHandler,
  onToggleClick,
  onDuplicate,
  onDelete,
  handleResetClick,

  // Additional props
  getLockHoursHandler,
  globalConfig,
  setClickId,
  showPopup,
  clickId,

  // Refs
  activedropdownRefs,

  // Styling
  className = "custom-dropdown12",
  style = {},
  showTimeEntryPopup = false,
  showTimeEntryPopupCondition,
}) => {
  const currentItem = row || group;
  const currentItemId = itemId || currentItem?._id;
  // Local anchor so each instance (mobile vs desktop) positions from its own node.
  const anchorRef = useRef(null);

  const handleToggle = () => {
    if (onToggleClick) {
      onToggleClick();
    } else if (createActionsDropdownToggleHandler && currentItem) {
      createActionsDropdownToggleHandler({
        group: currentItem,
        getLockHoursHandler,
        globalConfig,
        handleDropdownToggleFunc,
        setClickId,
      })();
    } else if (handleDropdownToggleFunc && currentItemId) {
      handleDropdownToggleFunc(currentItemId);
    }
  };

  const handleDuplicate = (e) => {
    e.stopPropagation();
    if (onDuplicate) {
      onDuplicate(e);
    }
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    if (onDelete) {
      onDelete(e);
    } else if (handleResetClick && currentItemId && currentItem) {
      !isDeleteLoading && handleResetClick(currentItemId, currentItem);
    }
  };

  return (
    <div
      className={className}
      style={style}
      data-actions-id={currentItemId || undefined}
      ref={(el) => {
        if (!activedropdownRefs || !currentItemId) {
          anchorRef.current = el;
          return;
        }
        if (!el) {
          if (activedropdownRefs.current[currentItemId] === anchorRef.current) {
            delete activedropdownRefs.current[currentItemId];
          }
          anchorRef.current = null;
          return;
        }
        anchorRef.current = el;
        // Prefer the visible instance (mobile on small screens, desktop on large).
        // Overwriting with a display:none twin breaks outside-click + positioning.
        const existing = activedropdownRefs.current[currentItemId];
        if (isElementVisible(el) || !existing || !isElementVisible(existing)) {
          activedropdownRefs.current[currentItemId] = el;
        }
      }}
    >
      <div
        className="dropdown-toggle1"
        onClick={handleToggle}
      >
        <ThreeDotsMenuIcon />
      </div>

      {renderActionsDropdown({
        isOpen: activeDropdownId === currentItemId,
        activeId: activeDropdownId,
        itemId: currentItemId,
        duplicateLoading,
        isDeleteLoading,
        deleteId,
        onDuplicate: handleDuplicate,
        onDelete: handleDelete,
        anchorEl: anchorRef.current,
      })}

      {showTimeEntryPopup && showTimeEntryPopupCondition && (
        <div>
          <TimeEntryPopup
            onClose={() => {
              if (setClickId) {
                setClickId(null);
              }
            }}
          />
        </div>
      )}
    </div>
  );
};

export default ActionsDropdownWrapper;
